import { MutableRefObject } from "react";
import { TAcquisitionState } from "../../providers/ModernAcquisitionProvider/types";
import { AcquisitionFlow, getAcquisitionFlow } from "../../utils/acquisition-utils";

const modernFormControlManager = (personalInformation: MutableRefObject<TAcquisitionState>) => {
    const validatePersonalInformation = () => {
        if (
            getAcquisitionFlow() === AcquisitionFlow.PqOfOne ||
            getAcquisitionFlow() === AcquisitionFlow.PHA
        ) {
            return true;
        }
        
        return !Object.values(personalInformation.current).some(
            fieldValue => fieldValue.state === 'error' || fieldValue.errorType !== 'None',
        );
    }

    return {
        validatePersonalInformation,
    }
}

export default modernFormControlManager;